var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
/* eslint-disable react/hook-use-state -- Intentional*/
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- Intentional*/
import { useCallback, useState } from 'react';
import { INITIAL_RESET_RECORD_KEY, NO_RESET_KEY, ROOT_RESET_RECORD_KEY, STORAGE_RESET_KEY, } from '../../constants';
import { useUpdate, useUpdatedRef } from '../../custom-hooks';
export const useRootForm = ({ formData, initialResetState, isUsingStorage, }) => {
    _react_refresh_temp_1();
    const [fieldsToBeSet, setFieldsValueState] = useState({});
    const [errors, setErrors] = useState({});
    const [injectedErrors, setInjectedErrors] = useState({});
    const [isPristine, setIsPristine] = useState(true);
    const [focusedField, focusField] = useState('');
    const [scrolledField, scrollFieldIntoView] = useState('');
    const [forceValidateFlag, setForceValidateFlag] = useState(null);
    const [resetFlag, setResetFlag] = useState({
        resetKey: NO_RESET_KEY,
    });
    const [resetRecords, setResetRecords] = useState({});
    const setFieldsValue = useCallback((value) => setFieldsValueState((prevState) => ({ ...prevState, ...value })), []);
    const injectErrors = useCallback((value) => setInjectedErrors(value), []);
    const forceValidate = useCallback((customForceValidateFlag = {}) => {
        setForceValidateFlag(customForceValidateFlag);
    }, []);
    const [isEdit, setIsEdit] = useState(false);
    const registerFieldErrors = useCallback(({ fieldErrors, fieldId }) => {
        setErrors((currentErrors) => {
            if (fieldErrors.length === 0) {
                const newErrors = { ...currentErrors };
                delete newErrors[fieldId];
                return newErrors;
            }
            return {
                ...currentErrors,
                [fieldId]: fieldErrors,
            };
        });
    }, []);
    const setDirty = useCallback(() => setIsPristine(false), []);
    const cancel = useCallback(() => {
        setIsEdit(false);
        setResetFlag({ resetKey: ROOT_RESET_RECORD_KEY });
        setTimeout(() => {
            setResetRecords((currentResetRecords) => {
                const newResetRecords = { ...currentResetRecords };
                delete newResetRecords[ROOT_RESET_RECORD_KEY];
                return newResetRecords;
            });
        });
    }, []);
    const formDataRef = useUpdatedRef(formData);
    const edit = useCallback(() => {
        setIsEdit(true);
        setResetRecords((currentResetRecords) => {
            return {
                ...currentResetRecords,
                [ROOT_RESET_RECORD_KEY]: formDataRef.current,
            };
        });
    }, [setResetRecords]); // formData makes Form test hang
    const save = useCallback(() => {
        setIsEdit(false);
        setResetRecords((currentResetRecords) => {
            const newResetRecords = { ...currentResetRecords };
            delete newResetRecords[ROOT_RESET_RECORD_KEY];
            return newResetRecords;
        });
    }, []);
    const getFieldId = useCallback(() => '', []);
    const isUsingStorageRef = useUpdatedRef(isUsingStorage);
    const reset = useCallback(({ resetList } = {}) => {
        if (resetList) {
            setResetFlag({ resetKey: NO_RESET_KEY, resetList });
        }
        else {
            setResetFlag({
                resetKey: isUsingStorageRef.current
                    ? STORAGE_RESET_KEY
                    : INITIAL_RESET_RECORD_KEY,
            });
            setIsPristine(true);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Intentional
    []);
    // Store the initial reset state
    // in the resetRecords:
    useUpdate(() => {
        if (isPristine) {
            setResetRecords((currentResetRecords) => ({
                ...currentResetRecords,
                [INITIAL_RESET_RECORD_KEY]: formData,
            }));
        }
        if (isUsingStorage && initialResetState) {
            setResetRecords((currentResetRecords) => ({
                ...currentResetRecords,
                [INITIAL_RESET_RECORD_KEY]: initialResetState,
            }));
        }
    }, [formData, initialResetState]);
    return {
        cancel,
        edit,
        errors,
        fieldsToBeSet,
        focusedField,
        focusField,
        forceValidate,
        forceValidateFlag,
        getFieldId,
        injectedErrors,
        injectErrors,
        isEdit,
        isPristine,
        registerFieldErrors,
        reset,
        resetFlag,
        resetRecords,
        save,
        scrolledField,
        scrollFieldIntoView,
        setDirty,
        setFieldsValue,
        setIsPristine,
        setResetFlag,
        setResetRecords,
    };
};
_react_refresh_temp_1(useRootForm, "mKViqS510PbSEML/HY8iPhddm/w=", false, () => [useUpdatedRef, useUpdatedRef, 
    // Store the initial reset state
    // in the resetRecords:
    useUpdate]);
